import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { fieldTemplateService } from '../../../services/fieldTemplateService'
import ConditionalEnableDisableItemEditUI from './ConditionalEnableDisableItemEditUI'
import { toast } from 'react-toastify'

export const OPERATIONS = {
  LTE: 'lte',
  LT: 'lt',
  GTE: 'gte',
  GT: 'gt',
  EQUAL: 'eq',
}

const ConditionalEnableDisableUI = ({ field, activityTemplateId }) => {
  const { user } = useAuthContext()
  const [fields, setFields] = useState([])

  const [constraints, setConstraints] = useState([])

  useEffect(() => {
    ;(async () => {
      if (user && activityTemplateId) {
        const allFieldResult = (
          await fieldTemplateService.getAllFieldsInActivity(user, activityTemplateId)
        ).data

        // add table field name for subfields
        const updatedFields = allFieldResult?.map((it) => {
          const tf = it.is_subfield
            ? allFieldResult.find((tf) => tf.id == it.table_field_template_id)
            : null
          return {
            ...it,
            field_template_name: tf
              ? tf.field_template_name + '/' + it.field_template_name
              : it.field_template_name,
            table_field_template: tf,
          }
        })

        setFields(updatedFields)

        const constraintResult = (
          await fieldTemplateService.getConditionalEnableDisable(user, activityTemplateId)
        ).data

        const pureConstraints = constraintResult
          ?.filter((it) => it.destination_field_template_id == field.id)
          .map((it) => ({
            id: it.id,
            source_field_template_id: it.source_field_template_id,
            destination_field_template_id: it.destination_field_template_id,
            enable_on_value: it.enable_on_value,
            operation: it.operation,
          }))

        setConstraints(pureConstraints)
      }
    })()
  }, [])

  const saveChanges = async () => {
    try {
      const updatedConstraints = await fieldTemplateService.addConditionalEnableDisable(
        user,
        field.id,
        constraints
      )
      setConstraints(updatedConstraints)
      toast.success('Added successfully')
    } catch (error) {
      toast.error('Error while adding conditional enabling/disabling')
    }
  }

  const addRow = () => {
    setConstraints([
      ...constraints,
      {
        id: new Date().getTime(),
        source_field_template_id: null,
        destination_field_template_id: field.id,
        enable_on_value: null,
        operation: null,
      },
    ])
  }

  const deleteRow = (id) => {
    setConstraints(constraints.filter((it) => it.id != id))
  }

  return (
    <Box>
      <Typography variant="p">Conditional Enabling</Typography>
      {constraints?.map((constraintItem) => {
        return (
          <ConditionalEnableDisableItemEditUI
            fields={fields}
            constraintItem={constraintItem}
            onDelete={deleteRow}
            selectedField={fields.find((it) => it.id == constraintItem.source_field_template_id)}
            updateConstraint={(updated) => {
              setConstraints(
                constraints.map((it) => {
                  return it.id == updated.id ? updated : it
                })
              )
            }}
          />
        )
      })}
      <div
        style={{
          display: 'flex',
          columnGap: 16,
          width: '100%',
          justifyContent: 'flex-end',
          marginTop: 16,
        }}
      >
        <Button variant="outlined" onClick={() => addRow()}>
          Add
        </Button>
        <Button color="primary" variant="contained" onClick={saveChanges}>
          Save Changes
        </Button>
      </div>
    </Box>
  )
}

export default ConditionalEnableDisableUI
